import axios from "axios";

export const apiURL = "https://api.vibe-stream.tv";

export const getFeaturedList = () => {
  return axios.get(apiURL + "/featured/videos");
};

export const getPlaylist = (id, params = {}) => {
  return axios.get(`${apiURL}/playlist/${id}/videos`, {
    params,
    paramsSerializer: {
      indexes: null,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`
    }
  });
};

export const getPlaylistGenres = (id) => {
  return axios.get(`${apiURL}/playlist/${id}/genre`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`
    }
  });
};

export const getSingleVideo = (uuid) => {
  return axios.get(`${apiURL}/v3/video/${uuid}`);
};

export const getAllPlaylist = () => {
  return axios.get(`${apiURL}/combined-categories`);
};

// data = {id: "videoId", device: "web", duration: "watchedDuration"}
export const recordVideoAnalytics = (data) => {
  return axios.post(`${apiURL}/video/analytics`, data);
}

export const getWebCategories = () => {
  return axios.get(`${apiURL}/web-categories`);
}

export const getFeaturedPlaylistVideos = (time) => {
  return axios.get(`${apiURL}/v4/featured/videos?time=${time}`);
}

export const searchVideos = (params) => {
  return axios.get(`${apiURL}/v4/video/search`, { params });
};
